import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useState, useEffect } from "react";
import ReactModal from "react-modal";
import axios from "axios";

const CrearUsuario = () => {
  const [postUsuario, setPostUsuario] = useState("");
  const [postNombre, setPostNombre] = useState("");
  const [postDireccion, setPostDireccion] = useState("");
  const [postMunicipio, setPostMunicipio] = useState("");
  const [postTelefono, setPostTelefono] = useState("");
  const [postCorreo, setPostCorreo] = useState("");
  const [postTipoUsuario, setPostTipoUsuario] = useState("");
  const [postRegional, setPostRegional] = useState("");
  const [postTalleres, setPostTaller] = useState("");
  const [postContrasena, setPostContrasena] = useState("");

  const [tipoUsuarioOptions, setTipoUsuarioOptions] = useState([]);
  const [regionalOptions, setRegionalOptions] = useState([]);
  const [talleres, setTalleres] = useState([]);
  const [documento, setDocumento] = useState([]);

  const [modalIsOpen, setIsOpen] = useState(false);

  useEffect(() => {
    axios
      .get(
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerTipoUsuarios",
      )
      .then((response) => setTipoUsuarioOptions(response.data))
      .catch((error) => console.error("Error fetching tipoUsuario:", error));

    axios
      .get(
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerRegional",
      )
      .then((response) => setRegionalOptions(response.data))
      .catch((error) => console.error("Error fetching regional:", error));

    axios
      .get(
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerTalleres",
      )
      .then((response) => setTalleres(response.data))
      .catch((error) => console.error("Error fetching talleres:", error));
  }, []);

  const handleOpenModalTest = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const postData = (e) => {
    e.preventDefault();
    const tallerId = postTalleres ? postTalleres : 0;

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/CreaUsuarios",
      data: {
        usuario: postUsuario,
        nombre: postNombre,
        direccion: postDireccion,
        municipio: postMunicipio,
        telefono: postTelefono,
        correo: postCorreo,
        tipoUsuarioId: postTipoUsuario,
        estado: "Activo",
        regional: postRegional,
        tallerId: tallerId,
        contrasena: postContrasena,
        Documento: documento,
      },
    })
      .then((response) => {
        console.log(response.data);
        alert("Usuario creado con éxito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear usuario: " + error);
      });
  };

  return (
    <>
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Nuevo
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Usuario"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">USUARIO</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <br></br> <br></br>
                  <Form>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Usuario
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-username"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostUsuario(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Nombre
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-email"
                              type="text"
                              onChange={(e) => setPostNombre(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Dirección
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-last-name"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostDireccion(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Municipio
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-username"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostMunicipio(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Telefono
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-email"
                              type="text"
                              onChange={(e) => setPostTelefono(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Correo
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-last-name"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostCorreo(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Contraseña
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-last-name"
                              placeholder=""
                              type="password"
                              onChange={(e) =>
                                setPostContrasena(e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Correo
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-last-name"
                              placeholder=""
                              type="text"
                              onChange={(e) => setPostCorreo(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              N° Documento
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-last-name"
                              type="text"
                              onChange={(e) => setDocumento(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Tipo Usuario
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-username"
                              type="select"
                              onChange={(e) =>
                                setPostTipoUsuario(e.target.value)
                              }
                            >
                              <option value="">Seleccionar</option>
                              {tipoUsuarioOptions.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.nombre}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input"
                            >
                              Regional
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input"
                              type="select"
                              onChange={(e) => setPostRegional(e.target.value)}
                            >
                              <option value="">Seleccionar</option>
                              {regionalOptions.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.nombre}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      {postTipoUsuario == 3 ? (
                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-username"
                              >
                                seleccionar el Taller
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-username"
                                type="select"
                                onChange={(e) => setPostTaller(e.target.value)}
                              >
                                <option value="">Seleccionar</option>
                                {talleres.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.nombreTaller}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                        </Row>
                      ) : (
                        <h></h>
                      )}
                      <Row>
                        <button
                          className="btn btn-primary btn-lg"
                          color="primary"
                          onClick={postData}
                        >
                          ENVIAR
                        </button>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CrearUsuario;
